<template>
    <div
        v-tippy="
            user.crmOutOfFunds()
                ? {
                      placement: placement,
                      content: message,
                      allowHTML: true,
                      interactive: true,
                  }
                : null
        "
    >
        <button :disabled="user.crmOutOfFunds() || !user.can(can)" v-bind="$attrs" class="disabled:cursor-not-allowed button">
            <slot />
        </button>
    </div>
</template>

<script>
export default {
    props: {
        placement: {
            type: String,
            default: 'right',
        },
        can: {
            type: String,
            default: null,
        },
    },
    computed: {
        user() {
            return this.$authSanctum.getUser()
        },
        message() {
            if (!this.user.can(this.can)) {
                return this.$en.crm[this.can]
            }

            if (this.user.crmOutOfFunds()) {
                return this.$en.crm.funds(this.user.crmLink())
            }

            return null
        },
    },
}
</script>
